<template>
<div class="chapter">
<div class="inner_page">
<a id="p1"></a>
<div class="copyright">
<p class="center ">First Mariner Books edition 2016</p>
<p class="center ">Copyright © 2015 by Spellman Enterprises, Inc.</p>
<p class="center spaceabove1">All rights reserved</p>
<p class="center spaceabove1">For information about permission to reproduce selections from this book, write to <a href="mailto:trade.permissions@hmhco.com">trade.permissions@hmhco.com</a> or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.</p>
<p class="center spaceabove1"><a href="https://hmhbooks.com/" target="_blank">hmhbooks.com</a></p>
<p class="center spaceabove1"><em>Library of Congress Cataloging-in-Publication Data</em></p>
<p class="center ">Lutz, Lisa.<br/>
How to start a fire / Lisa Lutz.</p>
<p class="center ">pages ; cm</p>
<p class="center "><span class="smallcaps">ISBN</span> 978-0-544-41163-0 (hardcover)—<span class="smallcaps">ISBN</span> 978-0-544-40964-4 (ebook)—<span class="smallcaps">ISBN</span> 978-0-544-70518-0 (pbk.)</p>
<p class="center ">1. Female friendship—Fiction. 2. Life change events—Fiction. 3. Chick lit. I. Title.</p>
<p class="center "><span class="smallcaps">PS</span>3612.<span class="smallcaps">U</span>897 <span class="smallcaps">H</span>69 2015</p>
<p class="center ">813'.6—dc23</p>
<p class="center ">2014033603</p>
<p class="center spaceabove1">Cover design by Christopher Moisan</p>
<p class="center ">Cover illustration © Maria Cecilia Azzali</p>
<p class="center ">Author photograph © David Hayward</p>
<p class="center spaceabove1">Excerpt from “Highway 61 Revisited” by Bob Dylan. Copyright © 1965 by Warner Bros. Inc.; renewed 1993 by Special Rider Music. All rights reserved. International copyright secured. Reprinted by permission.</p>
<p class="center spaceabove1">Excerpt from “The New Music” by Donald Barthelme. Copyright © 1981, 1982 by Donald Barthelme, currently collected in <em>Sixty Stories</em>, used by permission of The Wylie Agency, LLC.</p>
<p class="center spaceabove1">“Earth People,” Words and Music by Daniel Nakamura and Keith Thornton © 1997 Oct Music (ASCAP)/Reservoir Media Music (ASCAP). Administered by Reservoir Media Management, Inc. All Rights Reserved. Used by Permission of Alfred Music.</p>
<p class="center spaceabove1">v4.0220</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?55b59473